<template>
<div class="m-2">
    <loading-spinner v-if="loading" />
    <template v-else>
      <div class="row">
        <div class="column">
            <h5>Select a date range</h5>
            <vue-ctk-date-time-picker
            id="RangeDatePicker"  label="Current Month" v-model="range_value"
            format="YYYY-MM-DD" range = true formatted="ll">
              <b-button variant="primary"
                class="m-2" size="md">Current Month</b-button>
          </vue-ctk-date-time-picker>
        </div>
        <div class="column">

        </div>
      </div>
    </template>
</div>
</template>

<script>
import axios from "axios";
import { fullURL } from "../../utils";
import LoadingSpinner from "../LoadingSpinner";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import moment from "moment";

  export default {
    name: 'ReportSummary',
    components: {
    LoadingSpinner,
  

    VueCtkDateTimePicker
  },
    
    watch: {
      "$route.params.id"(id) {
        this.customerID = id;
      },
    range_value(val){
      const {start, end} = val;
      console.log("startDATE", start);
      
      }
    },
    data() {
      return {
        customerID: this.$route.params.id,
        range_value:null,
        // collection_: this.$route.params.collection,
        filter: {
          method: "dynamic",
          values: {
            logic: "and",
            filters: []
          }
        },
        
      };

    },

    created(){
    const today = new Date();
    const start = new Date(today.getFullYear(), 0, 1, 1).toISOString().slice(0, 10);
    const end_date = new Date(today.getFullYear(), today.getMonth() + 1, 1, 1);
    end_date.setDate(end_date.getDate() - 1);
    const end = end_date.toISOString().slice(0, 10);
    const current_month = today.getMonth() + 1;
    const current_year = today.getFullYear()

    axios({
    method: 'post',
    url: fullURL('/custom-reports/agent-report/summary'),
    data: {
        "year": today.getFullYear(),
        "month": today.getMonth() + 1,
        "customer_id": parseInt(this.customerID)}
    }
    ).then(
        ({data}) =>{
            console.log("reportsummary", data)
        }
    );
    // axios.post(
    //     fullURL('/custom-reports/agent-report/summary'),{"year": today.getFullYear(), "month": today.getMonth() + 1,"customer_id": parseInt(this.customerID)})
    // ).then(
    //     ({data}) =>{
    //         console.log("reportsummary", data)
    //     }
    // )

    }



    
  }
</script>


